import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 2000 },
    maxAttempts: { type: Number, default: 5 },
    url: String
  }

  connect() {
    if (this.attempts >= this.maxAttemptsValue) return

    this.timeout = setTimeout(() => this.refresh(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  async refresh() {
    this.attempts += 1

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })

      if (!response.ok) return

      const html = await response.text()
      window.Turbo.renderStreamMessage(html)

      if (!html.includes('data-controller="invoice-refresh"')) {
        sessionStorage.removeItem(this.storageKey)
      }
    } catch (error) {
      console.warn("Unable to refresh invoice status", error)
    }
  }

  get attempts() {
    return Number(sessionStorage.getItem(this.storageKey) || 0)
  }

  set attempts(value) {
    sessionStorage.setItem(this.storageKey, value)
  }

  get storageKey() {
    return `invoice-refresh-attempts:${this.urlValue}`
  }
}
